import { render, staticRenderFns } from "./UserPoints.vue?vue&type=template&id=2a083659&"
import script from "./UserPoints.vue?vue&type=script&lang=js&"
export * from "./UserPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a083659')) {
      api.createRecord('2a083659', component.options)
    } else {
      api.reload('2a083659', component.options)
    }
    module.hot.accept("./UserPoints.vue?vue&type=template&id=2a083659&", function () {
      api.rerender('2a083659', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/UserPoints.vue"
export default component.exports